module.exports = __webpack_public_path__ + "img/Capture d’écran 2021-12-02 à 16.02.08.238db9ec.png";